import { Modal } from 'components/Overlay'
import Spinner from 'components/Spinner'
import { bool, func } from 'prop-types'
import { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { authorization } from 'store/user'
const Logout = ({ visible = false, setVisible }) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [loading, setLoading] = useState(false)
	const logout = () => {
		localStorage.clear()
		dispatch(authorization({ STATUS: 'ERROR', user: null }))
		navigate('/auth?tab=0')
	}
	return (
		<Modal
			isDisabled={loading}
			maxWidth='500px'
			onClose={() => setVisible(false)}
			onOpen={() => setVisible(true)}
			open={visible}
		>
			<div className='py-[32px] px-[24px]'>
				<h4 className='text-[24px] font-bold m-0 text-center text-[#292B32] dark:text-[#f2f2f2]'>
					Hisobdan chiqish
				</h4>
				<p className='text-lg font-medium mx-0 mt-[16px] mb-[0] text-center text-[#292B32] dark:text-[#f2f2f2]'>
					Haqiqatan ham hisobingizdan chiqmoqchimisiz?
				</p>
				<div className='flex justify-center items-center mt-[24px]'>
					{loading ? (
						<div className='flex h-[48px] items-center justify-center'>
							<Spinner />
						</div>
					) : (
						<Fragment>
							<button
								className='mute-btn mr-5 min-w-[150px]'
								onClick={() => setVisible(false)}
							>
								Bekor qilish
							</button>
							<button className='danger-btn min-w-[150px]' onClick={logout}>
								Ha
							</button>
						</Fragment>
					)}
				</div>
			</div>
		</Modal>
	)
}
Logout.propTypes = {
	visible: bool,
	setVisible: func,
}
export default Logout
